import { Box } from '@material-ui/core';
import React from 'react';

import { ReactComponent as PersonIcon } from '../../../shared/assets/icons/person.svg';
import { ReactComponent as TableIcon } from '../../../shared/assets/icons/table.svg';
import { lightTheme } from '../lib/theme';
import { ArrowButton } from './arrowButton';
import { Duo } from './duo';
import { SvgIcon } from './svgIcon';

const { fg } = lightTheme;
// const { color } = lightTheme.theme;

export const ReserveFooterWidget = ({
  room,
  tables,
  persons,
  collapsed = false,
  onClickCollapse,
  forcedOpen = false,
  // compact = false,
}: {
  room: string;
  tables: string[];
  persons: number;
  collapsed?: boolean;
  onClickCollapse: (nextCollapsed: boolean) => void;
  forcedOpen?: boolean;
  // compact?: boolean;
}) => {
  const style: React.CSSProperties = {
    // background: color.neutral[800],
    // color: color.neutral[0],
    background: 'transparent',
    marginTop: '-8px',
  };

  const handleOnClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    onClickCollapse(collapsed);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      color={fg.default}
      // mt={compact ? '8px' : '16px'}
      mt="16px"
    >
      <Box flexGrow={1} display="flex" gridGap={32}>
        <Duo
          first={<SvgIcon icon={TableIcon} width={14} height={14} />}
          second={
            <Box flexDirection="column" lineHeight={1}>
              <Box fontWeight={600} fontSize={14} marginBottom="2px">
                {tables.join(', ')}
              </Box>
              <Box fontWeight={500} fontSize={12} color={fg.muted}>
                {room}
              </Box>
            </Box>
          }
          gridColumnGap={4}
        />
        <Duo
          first={<SvgIcon icon={PersonIcon} width={14} height={14} />}
          second={
            <Box fontWeight={600} fontSize={14} lineHeight={1}>
              {persons}
            </Box>
          }
          gridColumnGap={4}
        />
      </Box>
      {!forcedOpen && (
        <Box flexGrow={0}>
          <ArrowButton variant={collapsed ? 'down' : 'up'} onClick={handleOnClick} style={style} />
        </Box>
      )}
    </Box>
  );
};
